'use strict';

module.exports = function ($stateProvider) {

    $stateProvider
        .state('dashboard.departments.department.forms.data', {
            url: '/:formId/data?taskId',
            templateUrl: 'dashboard-data/dashboard-data.html',
            controller: 'dashboardDataCtrl as ctrl',
            resolve: {
                form: ['Authentication', '$stateParams', 'Form', function (Authentication, $stateParams, Forms) {
                    return Forms.find({
                        filter: {
                            "where": {
                                "id": $stateParams.formId
                            },
                            "include": [
                                { 
                                    "relation": "teams",
                                    "scope": {
                                        "include": [{
                                            "relation": "teamMembers",
                                            "scope": {
                                                "where": {
                                                    "isTeamLeader": true,
                                                    "memberId": Authentication.currentUser()
                                                }
                                            }
                                        }]
                                    }
                                },
                            ]
                        }
                    })
                        .$promise
                        .then(function (forms) {
                            return forms[0];
                        });
                }]
            },
            data: {
                authorizedRoles: ['admin', 'mobileUser', 'viewer']
            }
        });
};
